<ion-app>
  <ngx-ui-loader
  [fgsColor]="'#cad6fc'"
  [pbColor]="'#cad6fc'"
  [fgsType]="'ball-scale-multiple'">
  </ngx-ui-loader>
  <router-outlet id="main-content"></router-outlet>
  <div class="elfsight-app-266a70fa-fb41-4495-903a-1ca96694262c" data-elfsight-app-lazy></div>
</ion-app>
